<template lang="html">
  <!-- Modal -->
  <div :class="'modal fade modal-' + this.type" class="modal fade" id="bsModal" tabindex="-1" role="dialog" aria-labelledby="bsModalLabel" data-toggle="modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content box-success">
        <div class="modal-header">
          <i class="icon-modal"></i><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="bsModalLabel">{{title}}</h4>
         <p class="modal-description"></p>
        </div>
        <div class="modal-description">
               {{description}}
        </div>
        <div class="modal-footer">
          <button v-if="this.cancelText" type="button" class="btn btn-default" @click="cancel">{{cancelText}}</button>
          <button type="button" :class="'btn btn-' + this.type" @click="confirm">{{confirmText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const ModalTypes = ['modal-primary', 'modal-success', 'modal-info', 'modal-warning', 'modal-danger']
export default {
  mounted () {
    this.$bus.$on('modal-open', (args) => {
      this.type = args.type
      this.title = args.title
      this.body = args.body
      this.description = args.description
      this.confirmText = args.confirmText || 'Aceptar'
      this.cancelText = args.cancelText
      this.confirmBeforeHook = args.confirmBefore
      this.confirmAfterHook = args.confirmAfter
      this.cancelBeforeHook = args.cancelBefore
      this.cancelAfterHook = args.cancelAfter

      $('#bsModal').modal('show')
    })
    $('#bsModal').on('show.bs.modal', (e) => {
    })

    $('#bsModal').on('hidden.bs.modal', (e) => {
      this.confirmAfterHook()
      this.cancelAfterHook()
      this.resetProperties()
    })
  },
  data () {
    return {
      type: '',
      title: '',
      body: null,
      description: '',
      confirmText: '',
      cancelText: null,
      confirmBeforeHook: () => {},
      confirmAfterHook: () => {},
      cancelBeforeHook: () => {},
      cancelAfterHook: () => {}
    }
  },
  methods: {
    confirm: function () {
      this.confirmBeforeHook()
      $('#bsModal').modal('hide')
      this.cancelAfterHook = () => {}
    },
    cancel: function () {
      this.cancelBeforeHook()
      $('#bsModal').modal('hide')
      this.confirmAfterHook = () => {}
    },
    resetProperties: function () {
      this.type = ''
      this.title = ''
      this.description = ''
      this.confirmBeforeHook = () => {}
      this.confirmAfterHook = () => {}
      this.cancelBeforeHook = () => {}
      this.cancelAfterHook = () => {}
    }
  }
}
</script>

<style lang="css">

.modal-content {
	background: #FFFFFF;
  border: none !important;
}

.modal-info .modal-header{
  background: #FFFFFF !important;
    border:none !important;
}

.modal-title 
{
  color: #444444;		
  font-size: 14px;	
  font-weight: 600;
  line-height: 19px;
  text-transform:uppercase;
  border: none !important;
  border-color:none !important;
  display: inline ;
  padding-left: 6px;
  position: relative;
  top: 15px;
}

.modal-info .modal-body{
  background: #FFFFFF !important;
  border: none !important;
  border-color:none !important;
}

.modal-description{	
  color: #444444;		
  font-size: 16px;	
  line-height: 20px;
  border: none;
  position: relative ;
  top: 20px;
  padding: 10px 10px 0px 50px;
}

.modal-info .modal-footer{
 	background-color: #F2F4F6 !important;
  border: none;
  position: relative;
  top: 50px;
}

.btn-info{
  
    border-radius: 4px;	
    background-color: #009D00 !important;
    margin-top: 5px;
}

.icon-modal::before{
   content: url("/static/img/icons/exclamation-circle-solid-modal.png");
   position: relative;
   top: 20px;
   padding-left: 15px;
}


</style>



// WEBPACK FOOTER //
// Modal.vue?4a8a5f99